export class CallUnitEvent {
    Id?: number;
    DeviceUid: string;
    DeviceName: string;
    EventId: number;
    ModuleType: number;
    ButtonId: number;
    UnitName: string;
    EventDate: Date;
    CallAccessEvents: CallAccessEvent[];
}

export class CallAccessEvent {
    Id?: number;
    EventId: number;
    ParentId: number;
    Type: number;
    Code: string;
    Source: string;
    Result: number;
    EventDate: Date;
    ActionEvents: CallActionEvent[];
}

export class CallActionEvent {
    Id?: number;
    DeviceUid: string;
    EventId: number;
    ParentId: number;
    Source: string;
    Command: number;
    Result: number;
    EventDate: Date;
}

export class CallUnitExportLog {
    EventDate?: string;
    Button?: string;
    UnitName?: string;
    Result?: string;
    EventDateCallAccess?: string;
    Source?: string;
    Code?: string;
    ResultCallAccess?: string;
    EventDateAction?: string;
    CodeDtmf?: string;
    ActionDtmf?: string;
    ResultAction?: string;
}